module.exports = __webpack_public_path__ + "img/Location_Vancouver.a31e702e.png";